<template>
  <div>
    <custom-table index :data="data" :tableCode="tableCode" :column="tableColumn" @input="selectionChange" @filter="filterChange" @sort="sortChange" :filterArr="['action']"></custom-table>
  </div>
</template>

<script>
export default {
  name: '',
  mixins: [],
  components: {},
  props: {
    data: [Array],
    tableCode: [String],
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style></style>
